import { bffServiceClient } from '../../packages/request/clients';
import { getData } from 'helpers/request';
import { IJobsAdminResponse } from 'interfaces';

const getJobs = (): Promise<IJobsAdminResponse> => {
  return bffServiceClient.get('/logs/jobs').then(getData);
};

const runJob = (payload: { funcCode: string }): Promise<{}> => {
  return bffServiceClient.post('/logs/runjob', payload);
};

export default {
  getJobs,
  runJob,
};
